import React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { bindMenu } from 'material-ui-popup-state/hooks';
import Spin from 'components/Spin';
import useRequest from 'hooks/useRequest';
import { getTemplates } from 'services/messages.svc';

const QuickRepliesPopover = ({ type, popupState, onSelect }) => {
  const [templates, { loading, error }] = useRequest(getTemplates, {
    template_msg_type: type,
  });

  return (
    <Menu
      {...bindMenu(popupState)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Spin spinning={loading} />
      {templates?.map((item) => (
        <ListItem dense button key={item.hash} onClick={() => onSelect(item)}>
          <ListItemText primary={item.template_title} />
        </ListItem>
      ))}
      {!loading && !error && !templates?.length && (
        <Box p={1} color="text.secondary">
          No Templates found
        </Box>
      )}
    </Menu>
  );
};

export default QuickRepliesPopover;
